import React, { useState } from 'react';
import Header from '../components/header/Header.jsx';
import Footer from '../components/footer/Footer.jsx';
import FixedPlugin from '../components/fixedPlugin/FixedPlugin';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Contact = () => {
    const { isAuthenticated } = useAuth();
    const [formData, setFormData] = useState({
        email: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission logic here
        console.log('Form submitted:', formData);
    };

    return (
        <div className='min-h-screen bg-gray-50 dark:bg-gray-900'>
            <FixedPlugin />
            <Header />
            
            <main className='mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8 bg-gray-50 dark:bg-gray-900'>
                <div className='text-center mb-12'>
                    <h1 className='text-5xl font-bold text-gray-900 dark:text-white mb-4'>
                        Contact Us
                    </h1>
                    <p className='text-lg text-gray-600 dark:text-gray-300'>
                        Feel free to get in touch with any questions or inquiries.
                    </p>
                </div>

                <div className='grid grid-cols-1 lg:grid-cols-2 gap-12'>
                    {/* Left Column - Contact Form */}
                    <div className='space-y-6'>
                        <form onSubmit={handleSubmit} className='space-y-6'>
                            <div>
                                <label htmlFor='email' className='block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2'>
                                    Email
                                </label>
                                <input
                                    type='email'
                                    id='email'
                                    name='email'
                                    value={formData.email}
                                    onChange={handleChange}
                                    className='w-full px-4 py-3 border border-gray-300 dark:border-gray-600/50 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500/70 focus:border-transparent bg-white dark:bg-gray-800/50 text-gray-900 dark:text-white'
                                    placeholder='Enter your email'
                                    required
                                />
                            </div>

                            <div>
                                <label htmlFor='message' className='block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2'>
                                    Message
                                </label>
                                <textarea
                                    id='message'
                                    name='message'
                                    value={formData.message}
                                    onChange={handleChange}
                                    rows={6}
                                    className='w-full px-4 py-3 border border-gray-300 dark:border-gray-600/50 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500/70 focus:border-transparent bg-white dark:bg-gray-800/50 text-gray-900 dark:text-white resize-none'
                                    placeholder='Enter your message'
                                    required
                                />
                            </div>

                            <button
                                type='submit'
                                className='w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200'
                            >
                                Send Message
                            </button>
                        </form>
                    </div>

                    {/* Right Column - Contact Information */}
                    <div className='space-y-8'>
                        <div>
                            <h3 className='text-lg font-semibold text-gray-900 dark:text-white mb-2'>Email</h3>
                            <p className='text-gray-600 dark:text-gray-300'>info@valuepay.ai</p>
                        </div>

                        <div>
                            <h3 className='text-lg font-semibold text-gray-900 dark:text-white mb-2'>Call</h3>
                            <p className='text-gray-600 dark:text-gray-300'>+44 1234 567890</p>
                        </div>

                        <div>
                            <h3 className='text-lg font-semibold text-gray-900 dark:text-white mb-2'>Office</h3>
                            <p className='text-gray-600 dark:text-gray-300'>
                                123 Innovation Park,<br />
                                London, UK
                            </p>
                        </div>
                    </div>
                </div>

                {/* Company Footer */}
                <div className='text-center mt-16 py-8'>
                    <p className='text-gray-600 dark:text-gray-400 font-medium'>
                        HASNOVA TECHNOLOGIES LIMITED
                    </p>
                </div>
            </main>
            
            <Footer />
        </div>
    );
};

export default Contact;